// File: src/components/pages/tracker/ViewUpdateTracker.jsx
// View a student's live tracker and update stage completion status

import React, { useState } from 'react';
import { Search, CheckCircle2, Circle, ChevronDown, ChevronUp, Target } from 'lucide-react';
import '../../../styles/unified.css';

const MOCK_PUBLISHED = [
  {
    id: 'trk-3',
    studentName: 'Clara Patel',
    vehicleOption: 'Automatic',
    templateName: 'Intensive Automatic Course',
    stages: [
      { id: 1, name: 'Cockpit Checks & Controls',    completed: true  },
      { id: 2, name: 'Moving Off & Stopping',         completed: true  },
      { id: 3, name: 'Safe Positioning',              completed: true  },
      { id: 4, name: 'Mirrors, Signals & Manoeuvres', completed: false },
      { id: 5, name: 'Junctions — Turning Left',      completed: false },
      { id: 6, name: 'Junctions — Turning Right',     completed: false },
      { id: 7, name: 'Roundabouts',                   completed: false },
      { id: 8, name: 'Independent Driving & Test',    completed: false },
    ],
    numberOfClassesPaid:     8,
    numberOfClassesFinished: 3,
  },
];

const ViewUpdateTracker = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [trackers, setTrackers] = useState(MOCK_PUBLISHED);

  const filtered = trackers.filter(t =>
    t.studentName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleStage = (trackerId, stageId) => {
    setTrackers(prev =>
      prev.map(t => {
        if (t.id !== trackerId) return t;
        return {
          ...t,
          stages: t.stages.map(s =>
            s.id === stageId ? { ...s, completed: !s.completed } : s
          ),
        };
      })
    );
  };

  return (
    <>
        {/* Search */}
        <div className="search-bar" style={{ marginBottom: '1.25rem' }}>
          <Search size={20} className="search-icon" />
          <input
            type="text"
            placeholder="Search by student name..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="user-count">
          {filtered.length} tracker{filtered.length !== 1 ? 's' : ''} found
        </div>

        {filtered.length === 0 && (
          <div className="empty-state" style={{ marginTop: '2rem' }}>
            <Target size={48} style={{ color: '#94a3b8', marginBottom: '1rem' }} />
            <h3>No published trackers</h3>
            <p>Publish a tracker first to view and update it here.</p>
          </div>
        )}

        {/* Tracker cards */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          {filtered.map(tracker => {
            const completedCount = tracker.stages.filter(s => s.completed).length;
            const totalStages    = tracker.stages.length;
            const pct = totalStages > 0 ? Math.round((completedCount / totalStages) * 100) : 0;
            const isExpanded = expandedId === tracker.id;

            return (
              <div key={tracker.id} className="tracker-accordion">
                {/* Accordion header */}
                <button
                  className="tracker-accordion-header"
                  onClick={() => setExpandedId(isExpanded ? null : tracker.id)}
                >
                  <div className="user-name-cell">
                    <div className="user-avatar">{tracker.studentName.charAt(0)}</div>
                    <div>
                      <span className="user-name">{tracker.studentName}</span>
                      <span className="tracker-card-meta" style={{ display: 'block' }}>
                        {tracker.vehicleOption} &nbsp;·&nbsp; {tracker.templateName}
                      </span>
                    </div>
                  </div>

                  <div className="tracker-accordion-right">
                    {/* Mini progress */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <div className="progress-bar" style={{ width: 120 }}>
                        <div className="progress-fill" style={{ width: `${pct}%` }} />
                      </div>
                      <span className="progress-text">{completedCount}/{totalStages}</span>
                    </div>

                    {/* Payment vs finished pills */}
                    <span className="status-badge" style={{ backgroundColor: '#2563eb' }}>
                      Paid: {tracker.numberOfClassesPaid}
                    </span>
                    <span className="status-badge" style={{ backgroundColor: '#10b981' }}>
                      Done: {tracker.numberOfClassesFinished}
                    </span>

                    {isExpanded
                      ? <ChevronUp size={18} style={{ color: '#94a3b8' }} />
                      : <ChevronDown size={18} style={{ color: '#94a3b8' }} />}
                  </div>
                </button>

                {/* Stage checklist */}
                {isExpanded && (
                  <div className="tracker-stage-list">
                    {tracker.stages.map(stage => (
                      <div
                        key={stage.id}
                        className={`tracker-stage-row ${stage.completed ? 'stage-done' : ''}`}
                        onClick={() => toggleStage(tracker.id, stage.id)}
                      >
                        {stage.completed
                          ? <CheckCircle2 size={20} className="stage-icon-done" />
                          : <Circle       size={20} className="stage-icon-todo" />
                        }
                        <span className="tracker-stage-name">{stage.name}</span>
                        <span className="stage-status-label">
                          {stage.completed ? 'Completed' : 'Pending'}
                        </span>
                      </div>
                    ))}

                    <div className="tracker-stage-footer">
                      <button
                        className="btn-new"
                        style={{ fontSize: '0.85rem', padding: '0.5rem 1rem' }}
                        onClick={() => alert('Save changes — wire up API here')}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
    </>
  );
};

export default ViewUpdateTracker;